import React from 'react';
import PropTypes from 'prop-types';

// third party components
import { Grid } from '@mui/material';

// helpers
import { parseIntersection } from 'helpers';

const GridRow = ({label, value}) => {
  return (
    <>
      <Grid item xs={6}>
        <strong>{label}</strong>
      </Grid>
      <Grid item xs={6} alignItems="center" justify="flex-end">
        { value }
      </Grid>
    </>
  );
}

GridRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
}

const ProfileDetails = ({item, profileItemType}) => {

  let firstRowLabel = 'Parent Unit:';
  let firstRowValue = item?.parentUnitName;

  const unitTypesToHideWatershedIntersects = ['Census Designated Place', 'County', 'City'];

  let highPriorityAreaRowLabel = 'High Priority Area Intersections:';
  const highPriorityIntersectionArea = parseIntersection(item?.highPriorityIntersections);
  //most general value as default
  let units = 'acres';
  let highPriorityAreaValue = highPriorityIntersectionArea? `${highPriorityIntersectionArea} ${units}` : 'Not Available'

  switch (profileItemType) {
    case 'practice':
      if (item.geometry.type === 'LineString') {
        units = 'ft';
        //reapply proper units
        highPriorityAreaValue = highPriorityIntersectionArea? `${highPriorityIntersectionArea} ${units}` : 'Not Available';
      } else if (item.geometry.type === 'Point') {
        highPriorityAreaRowLabel = 'Intersects High Priority Area?';
        highPriorityAreaValue = item?.highPriorityIntersections? 'Yes' : 'No';
      }
      break;
    case 'unit':
      firstRowLabel = 'Unit Name:';
      firstRowValue = item?.unitName;
      break;
    default:
      break;
  }

  return (
    <>
      <Grid container spacing={2} sx={{paddingTop: 3}}>
        {/* 1st row */}
        <GridRow
          label={firstRowLabel}
          value={firstRowValue}
        />

        {(profileItemType === 'unit' ?
          <>
            <GridRow
              label="Unit Type:"
              value={item?.unitType}
            />

            <GridRow
              label="Property Ownership Type:"
              value={ item?.propertyOwnershipType ?? 'Not Applicable' }
            />
          </>
          : <></>)}

        {((profileItemType !== 'unit' || item?.unitType !== 'County')?
          <GridRow
            label={'County Intersections:'}
            value={parseIntersection(item?.countyIntersections) ?? 'Not Available'}
          />
          : <></>
        )}

        {((profileItemType !== 'unit' || item?.unitType !== 'Census Designated Place')?
          <GridRow
            label={'CDP Intersections:'}
            value={parseIntersection(item?.cdpIntersections) ?? 'Not Available'}
          />
          : <></>
        )}

        {((profileItemType !== 'unit' || item?.unitType !== 'City')?
          <GridRow
            label={'City Intersections:'}
            value={parseIntersection(item?.cityIntersections) ?? 'Not Available'}
          />
          : <></>
        )}

        {((profileItemType !== 'unit' || !unitTypesToHideWatershedIntersects.includes(item?.unitType))?
          <GridRow
            label={'Watershed (Huc 12) Intersections:'}
            value={parseIntersection(item?.watershedHuc12Intersections) ?? 'Not Available'}
          />
          : <></>)}

        <GridRow
          label={'Office Coverage Area Intersections:'}
          value={parseIntersection(item?.officeCoverageIntersections) ?? 'Not Available'}
        />

        <GridRow
          label={ highPriorityAreaRowLabel }
          value={ highPriorityAreaValue }
        />

      </Grid>
    </>
  );
}

ProfileDetails.propTypes = {
  item: PropTypes.object,
  profileItemType: PropTypes.string,
}

export default ProfileDetails;
